export default function () {
  this.loadProfessional()
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/form/resources/mounted.js